import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ModalController, NavParams, ViewController } from 'ionic-angular';
import { UtilsProvider } from '../../providers/utils/utils';

@Component({
  selector: 'page-formasdepago',
  templateUrl: 'formasdepago.html',
  providers: [  ]
})

export class FormasDePagoPage   implements OnInit {
  @Input() valorTotal: number=0;
  @Input() formasDePago: FormaPago[] = [];
  @Input() visualizarAtras: boolean = false;
  valorRestante: number = this.valorTotal;
  formattedValue: string = '';
  rawValue: number = 0;
  constructor(public modalControllers: ModalController,public utils: UtilsProvider,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.formasDePago = this.navParams.get('formasDePago')
    this.valorTotal = this.navParams.get('valorTotal')
    this.visualizarAtras = this.navParams.get('visualizarAtras')
    this.initializeFormattedValues();
   }

   initializeFormattedValues() {
    this.formasDePago.forEach(item => {
      item.formattedValor = this.formatNumber(item.valor);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['valorTotal']) {
      console.log('valorTotal cambiado:', this.valorTotal);
    }
    if (changes['formasDePago']) {
      console.log('formasDePago cambiado:', this.formasDePago);
    }
  }

  ngOnInit() {
    console.log('valorTotal:', this.valorTotal);
    console.log('formasDePago:', this.formasDePago);
  }

  validarSumaTotal() {
    const sumaTotal = this.formasDePago.reduce((sum:any, item:any) => sum + (item.valor || 0), 0);
    this.valorRestante = this.valorTotal - sumaTotal;
    if (sumaTotal > this.valorRestante) {
      console.log(`La suma total no puede superar el valor de ${this.valorTotal}.`);
    }
 }

  dismiss() {
    const formasDePagoFiltradas:any = this.formasDePago
    .filter((item:any) => item.valor > 0)
    .map(({ ...rest }) => ({
        ...rest,
        codigoFormaPago: rest.codigoFormaPago.trim()
    }));

    if (this.valorRestante < 0) {
      this.utils.mensajeMuestro('Formas de Pago', `La sumatoria de los valores no puede superar el valor total de: ${this.valorTotal}`, 'error');
      return;
    }
    if (this.valorRestante === 0) {
      this.viewCtrl.dismiss({formaDePagos:formasDePagoFiltradas})
    }
  }

    // Formatear el número con separadores de miles
    formatNumber(value: number): string {
      return value.toLocaleString('en-US');
    }

    // Desformatear el valor para almacenarlo
    parseNumber(value: string): number {
      return parseFloat(value.replace(/,/g, ''));
    }

    onInput(item: FormaPago, event: any) {
      const input = event.target.value;
      item.formattedValor = this.formatNumber(this.parseNumber(input));
    }

    onBlur(item: FormaPago) {
      item.valor = this.parseNumber(item.formattedValor || '0');
      this.validarSumaTotal();
    }

  ionViewDidLoad() {
    const element = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
    element.style.height = '100%';
    element.style.width = '100%';
    element.style.top = '0';
    element.style.left = '0';
    element.style.right = '0';
    element.style.bottom = '0';
  }
 // Cambiar el color del borde al enfocar
 setBorderColor(event: FocusEvent): void {
  const inputElement = event.target as HTMLElement;
  inputElement.style.borderBottomColor = '#007BFF'; // Azul al enfocar
}

// Restaurar el color del borde al perder el enfoque
resetBorderColor(event: FocusEvent): void {
  const inputElement = event.target as HTMLElement;
  inputElement.style.borderBottomColor = '#ccc'; // Gris al desenfocar
}
}

interface FormaPago {
  codigoFormaPago: string;
  nombreFormaPago: string;
  imagen: string;
  valor: number;
  formattedValor?: string;
}



// WEBPACK FOOTER //
// ./src/pages/formasdepago/formasdepago.ts